import {Component, Inject} from "@angular/core";
import {QuestionCardDirective} from "../../../directives/question-card/question-card.directive";
import {OfferJourneyService} from "../../../services/offer-journey/offer-journey.service";
import {FELLO_JOURNEY_TASK_ID} from "../../../injection-token";
import {FelloVisitorVariables, WallPaintColorIntensity} from "fello-model";

@Component({
  selector: "app-que-neutral-color-paint",
  templateUrl: "./que-neutral-color-paint.component.html",
  styleUrls: ["./que-neutral-color-paint.component.scss"]
})
export class QueNeutralColorPaintComponent extends QuestionCardDirective {
  options = [
    WallPaintColorIntensity.WALLS_NEUTRAL,
    WallPaintColorIntensity.NO_WALLS_NEUTRAL,
    WallPaintColorIntensity.MIX_MOSTLY_NEUTRAL,
    WallPaintColorIntensity.MIX_MOSTLY_BOLD,
    WallPaintColorIntensity.WALLPAPER
  ];
  labels: Record<WallPaintColorIntensity, string> = {
    [WallPaintColorIntensity.WALLS_NEUTRAL]: "Yes, walls are neutral",
    [WallPaintColorIntensity.NO_WALLS_NEUTRAL]: "No, no walls are neutral",
    [WallPaintColorIntensity.MIX_MOSTLY_NEUTRAL]: "Mix, but mostly neutral",
    [WallPaintColorIntensity.MIX_MOSTLY_BOLD]: "Mix, but mostly bold",
    [WallPaintColorIntensity.WALLPAPER]: "Wallpaper"
  };
  selectedOption?: WallPaintColorIntensity;
  constructor(public offerJourneyService: OfferJourneyService, @Inject(FELLO_JOURNEY_TASK_ID) public taskId: string) {
    super(offerJourneyService, taskId);
    this.selectedOption = this.offerJourney.vars.wallPaintColorIntensity;
  }

  next(): void {
    const vars: FelloVisitorVariables = {
      wallPaintColorIntensity: this.selectedOption
    };
    this.offerJourneyService.pushOfferJourneyTask(this.taskId, vars).subscribe();
  }
}
